import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dismissAlert } from "../../../api/alertsApi";

export const useDismissAlert = () => {
  const queryClient = useQueryClient();
  return useMutation((alertId: string) => dismissAlert(alertId), {
    // Invalidating the ["alerts"] prefix refreshes both useAlerts() and every useDashboardAlerts()
    // entry (react-query v4 matches invalidateQueries by key prefix). A refetch (not a manual cache
    // filter) is the right call now that a real backend is the source of truth for whether a
    // dismissed alert still shows, rather than this client guessing.
    onSuccess: () => queryClient.invalidateQueries(["alerts"]),
  });
};
